/*
 *
 * LoginPage constants
 *
 */

const prefix = 'ui/containers/LoginPage';

export const LOGIN_USER_START = `${prefix}/LOGIN_USER_START`;
export const LOGIN_USER_SUCCESS = `${prefix}/LOGIN_USER_SUCCESS`;
export const LOGIN_USER_ERROR = `${prefix}/LOGIN_USER_ERROR`;

export const FORGOT_PASSWORD_START = `${prefix}/FORGOT_PASSWORD_START`;
export const FORGOT_PASSWORD_SUCCESS = `${prefix}/FORGOT_PASSWORD_SUCCESS`;
export const FORGOT_PASSWORD_ERROR = `${prefix}/FORGOT_PASSWORD_ERROR`;
